/* Fransk katalog for locale-registry-control.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'control.example': 'Préparez une facture, créez un fournisseur ou modifiez l\'e-mail d\'un client …',
  'registry.customer': 'Clients',
  'registry.supplier': 'Fournisseurs',
  'registry.product': 'Produits',
  'registry.description': 'Description',
  'registry.price': 'Prix unitaire HT',
  'registry.type': 'Type',
  'registry.vat': 'Traitement de la TVA',
  'registry.sku': 'SKU',
  'registry.ean': 'EAN/GTIN',
  'registry.group': 'Groupe de produits',
  'registry.goods': 'Marchandise',
  'registry.service': 'Service',
  'registry.choose': 'Choisir …',
  'registry.newDraft': 'Nouvel enregistrement – non enregistré',
  'registry.selected': 'Sélectionné : {name}',
  'registry.archivedLabel': 'Archivé',
  'registry.matches': '{count} résultats. {shown} affichés. Précisez la recherche si plusieurs correspondent.',
  'registry.working': 'Travail dans le registre …',
  'registry.review': 'Vérifiez les informations dans le panneau du registre.',
  'registry.done.observed': 'Le registre est ouvert et les résultats sont affichés.',
  'registry.done.opened': 'L\'enregistrement du registre est ouvert.',
  'registry.repeatedRead': 'La même recherche dans le registre a déjà été effectuée. Vérifiez les résultats affichés avant de continuer.',
  'registry.done.applied': 'Les champs sont remplis. Les modifications ne sont pas encore enregistrées.',
  'registry.done.saved': 'L\'enregistrement du registre est sauvegardé.',
  'registry.done.archived': 'L\'enregistrement du registre est archivé.',
  'registry.done.restored': 'Le fournisseur est de nouveau actif.',
  'registry.done.unchanged': 'Aucune nouvelle modification à enregistrer.',
  'registry.changed': 'L\'enregistrement a été modifié depuis son ouverture. Fermez le panneau du registre et demandez-moi de le recharger.',
  'registry.selectFirst': 'Recherchez et sélectionnez d\'abord le bon enregistrement du registre.',
  'registry.unsupportedField': 'Ce champ n\'est pas pris en charge ici. Utilisez le formulaire habituel de la page.',
  'registry.unsupported': 'Cette action doit être effectuée dans le formulaire habituel de la page.',
  'registry.advancedProduct': 'Les modifications de TVA/type, d\'abonnement et de location doivent être effectuées dans le formulaire produit habituel.',
  'registry.archived': 'L\'enregistrement est archivé et ne peut pas être modifié ici.',
  'registry.authorization': 'Décrivez explicitement ce que vous souhaitez enregistrer, archiver ou rouvrir.',
  'registry.country': 'L\'enregistrement automatique dans le registre est pour l\'instant pris en charge pour les entreprises norvégiennes. Utilisez le formulaire habituel pour cette entreprise.',
  'registry.uncertain': 'L\'enregistrement n\'a pas été confirmé. Vérifiez l\'enregistrement sur la page avant de réessayer.',
  'registry.unsaved': 'Le panneau du registre contient des modifications non enregistrées. Enregistrez-les ou fermez d\'abord le panneau.',
  'registry.duplicate': 'Un autre enregistrement porte le même nom ou le même numéro d\'organisation. Fermez le panneau et choisissez l\'enregistrement existant correct, ou utilisez le formulaire habituel.',
});
